/**
 * Evidence some providers contribute inside a section another provider
 * compiles. A scoped or direct call that selects one of these providers must
 * also run its companions, or recompiling the section silently drops that
 * evidence.
 */
export const PROVIDER_COMPANIONS: Readonly<Record<string, readonly string[]>> = {
  // Jurisdiction is nested in the regulatory section: pair its local state
  // stance companion so a successful boundary screen is not discarded for
  // lack of a fabricated nuclear stance.
  'jurisdiction-boundaries': ['regulatory-db'],
  // The environmental section compiled from USFWS also carries four separate
  // lookups: the EPA NAAQS designation (`naaqsDesignations`) and the RD-1
  // refdata screens — PAD-US `protectedAreas`, EPA FRS `regulatedFacilities`
  // and Census AIANNH `tribalLands`. Every environmental refresh path (and
  // the client bootstrap's fast sweep) selects usfws-env only, so without
  // this pairing a scoped refresh deleted them. The server bootstrap's full
  // sweep always ran all four; this matches it.
  'usfws-env': ['epa-attainment', 'padus-protected', 'epa-frs', 'census-aiannh'],
};

/** `selected` plus the companions of every selected provider, deduplicated. */
export function withProviderCompanions(selected: readonly string[]): string[] {
  return Array.from(new Set([...selected, ...selected.flatMap(id => PROVIDER_COMPANIONS[id] ?? [])]));
}
